var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBnner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 376,
    height: 74,
    viewBox: "0 0 376 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bnner",
    transform: "translate(-232 -114)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57943",
    "data-name": "Group 57943",
    transform: "translate(232 114)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57945",
    "data-name": "Group 57945",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11650",
    "data-name": "Rectangle 11650",
    width: 376,
    height: 74,
    rx: 5,
    fill: "#f4f5f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_58036",
    "data-name": "Group 58036",
    transform: "translate(66.086 -19.963)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57944",
    "data-name": "Group 57944",
    transform: "translate(75 34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53600",
    "data-name": "Path 53600",
    d: "M280.45,106.3,255.958,81.812a3.358,3.358,0,0,0-4.749,0L220,113.021h67.965Z",
    transform: "translate(-194.137 -79.139)",
    fill: "#e7e9ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53602",
    "data-name": "Path 53602",
    d: "M227.934,86.184,204.6,109.195a3.34,3.34,0,0,0,2.354.967h47.017L232.988,86.184A3.359,3.359,0,0,0,227.934,86.184Z",
    transform: "translate(-204.598 -76.28)",
    fill: "#1a2d4c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_833",
    "data-name": "Ellipse 833",
    cx: 5.26,
    cy: 5.448,
    rx: 5.26,
    ry: 5.448,
    transform: "translate(33.814 0)",
    fill: "#e7e9ed"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_53686",
    "data-name": "Path 53686",
    d: "M0,0H92.414",
    transform: "translate(142.5 58.75)",
    fill: "none",
    stroke: "#e7e9ed",
    strokeLinecap: "round",
    strokeWidth: 5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnner);
export default __webpack_public_path__ + "static/media/bnner.1ec8c27d05f32385a24b9c2af471357c.svg";
export { ForwardRef as ReactComponent };